import axios from "axios";
import { userRequestHeaders } from "../user/index";

/**
 * Saves the given job's information to sessionStorage
 */
export function jobSetJob(job) {
	sessionStorage.setItem('job', JSON.stringify(job));
}

export function jobSetJobKeyValue(key, value) {
	const job = jobGetJob(); 
	job[key] = value;
	jobSetJob(job);
	return job;
}

/**
 * Returns user's job from sessionStorage, if one is set.
 * By default return null 
 *
 * @returns NULL / Object (job)
 */
export function jobGetJob() {
	let job = null;

	if (sessionStorage.getItem('job') !== null) {
		job = JSON.parse(sessionStorage.getItem('job'));
	}

	return job;
}

/**
 * Remove job's information from sessionStorage
 */
export function jobRemoveJob() {
	sessionStorage.removeItem('job');
}

/**
 * Save govid jobs to sessionStorage
 * @param {*} govidJobs 
 */
export function jobSetGovidJob(govidJobs) {
	sessionStorage.setItem('govidjobs', JSON.stringify(govidJobs));
}

/**
 * Get saved govid jobs from sessionStorage
 * @returns govid jobs
 */
export function jobGetGovidJob() {
	return JSON.parse(sessionStorage.getItem('govidjobs'));
}

/**
 * Fetch /rest/online/jobsearch/{dpid}
 *
 * Or invoicesearch with queryparameters
 *
 * /rest/online/jobsearch/dpid?querytype=invoice&reference=foo&billnum=bar&postcode=123
 *
 * Saves response to storage.
 * Dpid is also saved to storage.
 * 
 * If parameter is missing or dpid is not in storage, returns 400
 * On error returns Promise.reject(), with possible errormessage.
 *
 * @param query -
 * @returns {Promise<AxiosResponse<any> | never>}
 */
export function jobFetchJob(query = undefined) {
	let _query = "";

	// Add the query parameter if provided
	// Otherwise we won't expose the dpid for users who enter with a direct link
	if (typeof query !== "undefined" && query) {
		_query = "/" + query;
	}
	// Remove details of the previous job 
	jobRemoveJob();
	// fetch headers that can contain authorization information
	const headers = userRequestHeaders();

	return axios({
		method: "GET",
		url: import.meta.env.VITE_API_URL + "/online/jobsearch" + _query,
		headers: headers
	})
	.then(res => {
		if (res?.data === undefined) {
			throw new Error('No data in response');
		} else {
			// Save job's information to sessionStorage
			jobSetJob(res.data.job[0]);
			// Return Promise on success
			return Promise.resolve(res.data.job[0]);
		}
	})
	.catch(function (error) {
		return Promise.reject(error);
	});
}